import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { createBaseSelector, registerSlice } from '@shared/lib/redux'

import { routerRepository } from './router.repository'

export type RouterStore = {
  current: string | null
  prev: string | null
}

const initialState: RouterStore = routerRepository.getState()

const routerSlice = createSlice({
  name: 'routerSlice',
  initialState,
  reducers: {
    actualizeLocation: (state) => {
      state.current = state?.prev && state.prev !== `/signin` ? state.prev : '/'
      state.prev = null
    },
    saveCurrent: (state, action: PayloadAction<string | null>) => {
      state.current = action.payload
    },
    savePrev: (state, action: PayloadAction<string | null>) => {
      state.prev = action.payload
    },
    clearPrev: (state) => {
      state.prev = null
    },
    clearCurrent: (state) => {
      state.current = null
    }
  }
})

const routerBaseSelector = createBaseSelector(routerSlice)
const selectCurrentPath = createSelector(routerBaseSelector, (s) => s.current)
const selectPrevPath = createSelector(routerBaseSelector, (s) => s.prev)
const selectState = createSelector(routerBaseSelector, (s) => s)
const selectCurrent = createSelector(routerBaseSelector, (s) => s.current)

registerSlice([routerSlice])

export const routerStore = {
  actions: { ...routerSlice.actions },
  selectors: {
    selectCurrentPath,
    selectPrevPath,
    selectState,
    selectCurrent
  },
  name: routerSlice.name
}
